import React from "react";

import { Typeahead } from "../../../../form-inputs/typeahead";
import NotificationBar from "../../../../notification-bar";

const healthToAllergen = (healthClaim) => {
    switch (healthClaim) {
        case "Egg Free":
            return "Egg";
        case "Dairy Free":
        case "Milk Free":
            return "Milk";
        case "Gluten Free":
            return "Gluten";
        case "Peanut Free":
            return "Peanut";
        case "Lactose Free":
            return "Lactose";
        case "Fish Free":
            return "Fish";
        case "Soy Free":
            return "Soy";
        case "Wheat Free":
            return "Wheat";
        default:
            return "";
    }
};

const removeDuplicates = (data, prop) => {
    let map = new Map();
    data.forEach((element) => {
        map.set(element[prop], element);
    });

    var filteredData = [];
    map.forEach((value, key, i) => {
        filteredData.push(value);
    });

    return filteredData;
};

const HealthClaims = (props) => {
    const setClaims = async (name, values) => {
        // Update Allergy
        const allergyInfo = props.allergens;

        const allergyFromHealth = values.reduce((arr, value) => {
            const allergenCode = healthToAllergen(value.text);

            if (allergenCode) {
                const relativeAllergenOption = props.allergenOptions.find((allergen) => allergen.text === allergenCode);

                if (relativeAllergenOption) {
                    arr.push(relativeAllergenOption);
                }
            }

            return arr;
        }, []);

        allergyInfo.doesNotContain = removeDuplicates([...allergyInfo.doesNotContain, ...allergyFromHealth], "value");

        await props.updateField("allergens", allergyInfo);
        await props.updateField("healthClaims", values);
        document.getElementsByName(name)[0].focus();
    };

    return (
        <div className="panel-group">
            <h3>Health Claims</h3>
            <NotificationBar type="warning" message="Please use root attributes for Health Claims moving forward" />
            <Typeahead
                name="healthClaims"
                label="Health Claims"
                defaultValue={props.data && props.data.items ? props.data.items : []}
                options={props.healthClaimOptions}
                updateOnChange={setClaims}
                multiple={true}
                disabled={true}
            />
        </div>
    );
};

export default HealthClaims;
